import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

interface AuditLogsFilters {
  startDate: string;
  endDate: string;
  entity?: string;
  requestOrigin?: string;
  executorEmail?: string;
}

export const getAuditLogs = async (dispatch: Dispatch, query: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/admin/auditLogs?${query}`,
    dispatch,
  });
  if (response && response.data) return response.data;
  return [];
};
